<template>
  <div class="selector-container">
    <el-input v-model="filter" @input="handleFilter" :placeholder="$t('main.search')" :prefix-icon="Search"
      class="input-with-select">
      <template #append>
        <el-select v-model="type" placeholder="Select" style="width: 115px">
          <el-option :label="$t('common.all')" value="" />
          <el-option :label="$t('common.project')" value="projects" />
          <el-option :label="$t('common.folder')" value="folders" />
        </el-select>
      </template>
    </el-input>
    <div class="content">
      <template v-if="showProjects">
        <div class="my-projects">
          <span class="node-content">
            <!-- <i class="ri-group-fill"></i> -->
            <span class="node-label">{{ $t('main.project') }}</span>
          </span>
        </div>
        <el-tree highlight-current :icon="ArrowRightBold" node-key="id" lazy :load="loadNode"
          @current-change="handleCurrentChange" :expand-on-click-node="false" :props="{ class: 'node', label: 'name' }"
          :filter-node-method="filterNode" ref="treeRef">
          <template #default="{ node, data }">
            <span class="node-content" v-bind="node">
              <i v-if="node.level === 1" :class="(node.isCurrent ? 'ri-briefcase-fill' : 'ri-briefcase-line')"></i>
              <i v-else :class="(node.isCurrent ? 'ri-folder-fill' : 'ri-folder-line')"></i>
              <span class="node-label">{{ data.name }}</span>
            </span>
          </template>
        </el-tree>
      </template>
      <template v-if="showFolders">
        <div class="my-projects">
          <span class="node-content">
            <!-- <i class="ri-folder-fill"></i> -->
            <span class="node-label">{{ $t('common.folder') }}</span>
          </span>
        </div>
        <div class="folders">
          <div class="folder clickable" @click="handleFolderClick(folder)" v-for="folder in folders"
            :key="folder.id" :class="{ checked: current === folder }">
            <FileRow :file="folder" :height="36"></FileRow>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import FileRow from '../File/FileRow.vue';
import { Search, ArrowRightBold } from '@element-plus/icons-vue';
import { ComputedRef, Ref, computed, ref } from 'vue'
import { useStore } from '@/store';
import { ProjectService, SearchService } from '@/services';
import { ElMessage, ElTree as ElTreeEl } from 'element-plus';
import { Asset, Project } from '@/types';
const { modelValue } = defineProps<{ modelValue: string }>()
const emit = defineEmits(['update:modelValue', 'change'])

interface Tree {
  id: string
  project_id: string
  name: string
  children: Tree[]
}

const store = useStore()
const treeRef = ref<InstanceType<typeof ElTreeEl>>()
const filter = ref('')
const type = ref('')
const loading = ref(false)
const current: Ref<Asset | undefined> = ref()
const folders: Ref<Asset[]> = ref([])

const projects: ComputedRef<Tree[]> = computed(() => {
  return store.getters.sortedProjects.map((i: Project) => {
    return {
      name: i.name,
      id: i.root_asset,
      project_id: i.id,
      expand: false,
      children: []
    }
  })
})

const showProjects = computed(() => {
  return !(filter.value && type.value === 'folders')
})

const showFolders = computed(() => {
  return filter.value && type.value !== 'projects'
})

// 这里需要改造一下

const loadNode = async (node: { level: number, data: Tree }, resolve: (data: Tree[]) => void) => {
  console.log(node)
  if (node.level === 0) {
    resolve(projects.value)
  } else if (node.level === 1) {
    resolve((await ProjectService.get<Tree[]>(`${node.data.project_id}/folder_tree`)))
  } else {
    resolve(node.data.children || [])
  }
}

const filterNode = (value: string, data: Tree) => {
  // 只过滤project
  if (!value) return true
  return data.project_id && data.name.includes(value)
}

const handleCurrentChange = (data: Tree, node: { level: number, data: Tree }) => {
  console.log(data, node)
  current.value = void 0
  emit('update:modelValue', data.id)
  emit('change', data.id)
}

const handleFilter = async () => {
  treeRef.value?.filter(filter.value)
  if (showFolders.value) {
    loading.value = true
    folders.value = await SearchService.post('library', {
      filter: [{
        op: 'eq',
        key: 'type',
        value: 'folder'
      }],
      team: store.state.currentTeam?.code,
      keyword: filter.value
    }, {
      params: {
        page: 1,
        size: 10
      }
    })
    loading.value = false
  } else {
    folders.value = []
  }
}

const handleFolderClick = (folder: Asset) => {
  console.log(folder)
  treeRef.value?.setCurrentKey(null as any)
  current.value = folder
  emit('update:modelValue', folder.id)
  emit('change', folder.id)
}

</script>

<style lang="stylus" scoped>
.selector-container {
  padding: 16px;
  border-bottom: 1px solid #3b3b3b;
}
.content {
  height: 400px; 
  margin-top: 16px;
  overflow: auto;
}
:deep(.el-tree-node__content) {
  height: 40px;
  border-radius: 8px;
}
.folder {
  border-radius: 8px;
  &:hover {
    background-color: #262727;
  }
}
.checked, .checked:hover {
  background-color: var(--el-color-primary-light-9);
}
:deep(.comments) {
  color: #9a9a9a;
}

.node-content {
  display: flex;
  align-items: center;

  .node-label {
    margin-left: 5px;
  }
}
</style>